import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { UsrCred } from "./../../models/usrcred";
import { VproService } from "./../../service/vpro/vpro.service";
import { SocketsConnectionService } from "./../../service/websockets/connection.service";
import { Buffer } from 'buffer';
@Component({
  selector: 'app-login-new',
  templateUrl: './login-new.component.html',
  styleUrls: ['./login-new.component.css']
})
export class LoginNewComponent {

  user = new UsrCred();
  dataValue: boolean;
  dataValue2: number;
  dataValue3: string;
  dataValue4: number;
  innerHtml: string = "";
  awstok: string;
  isMutePass: boolean = false;
  rememberMe: boolean = false;
  isSuperAdmin: boolean = false;
  constructor(private spinner: NgxSpinnerService, private loginService: VproService, private utils: Utils, private router: Router, private activeRoute: ActivatedRoute, private socketsConnectionService: SocketsConnectionService) {
    if (localStorage.getItem("remember") !== undefined) {
      if (JSON.parse(localStorage.getItem("remember"))) {
        this.user.email_id = localStorage.getItem("username");
        this.user.password = localStorage.getItem("password");
        this.rememberMe = true;
      }
    }
  }

  ngOnInit() {
    if (this.activeRoute.snapshot.queryParams['role']) {
      this.isSuperAdmin = true;
      console.log("superadmin")
    } else
      this.user['account_type'] = "patient"
  }

  rememberMeChecked(evt) {
    if (evt && evt.target && evt.target.checked)
      this.rememberMe = evt.target.checked
  }

  /* authUser function for login */

  authUser() {
    localStorage.setItem("LogUsr", this.user.email_id.toLowerCase());  //getting Usr emailId

    try {
      this.spinner.show();
      if (this.user && this.user.email_id) {
        this.user.email_id = this.user.email_id.toLowerCase();
      }
      this.loginService.authUser(this.user).subscribe(
        (data) => {
          this.spinner.hide();

          this.dataValue = data["auth"];
          this.dataValue2 = data["roles"];
          this.dataValue3 = data["orgcode"];
          this.dataValue4 = data["uid"];

          localStorage.setItem("paid_account", data['paid_account'] || 'false');
          localStorage.setItem("orgcode", this.dataValue3);
          localStorage.setItem("LogUsrTyp", JSON.stringify(this.dataValue2));
          localStorage.setItem("uid", JSON.stringify(this.dataValue4));

          if (this.rememberMe) {
            localStorage.setItem('remember', JSON.stringify(true));
            localStorage.setItem("username", this.user.email_id);
            localStorage.setItem("password", this.user.password);
          } else {
            localStorage.setItem('remember', JSON.stringify(false));
          }
          this.socketsConnectionService.subscribeToSockets();
          this.awstok = data["stok"];

          if (this.user && this.user.account_type && this.user.account_type == Utils.ALLOWED_TYPE.PATIENT && data && data["password_reset"] == true) {

            localStorage.setItem("token2", this.awstok);
            // SweetAlert
            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Patient",
            });

            this.router.navigate(["/patient/members"]);
          }

          // Check for activation status
          if (data && this.dataValue == false) {
            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 5000,
            });

            Toast.fire({
              type: "warning",
              title: "Access Denied",
              text: "Check your mail for activation link and get it verified",
            });

          }

          if (this.dataValue2 === 9) {
            console.log("Sorry");
            this.innerHtml =
              "    <b>Sorry ..! Please check your Credentials</b>";
          }

          if (this.dataValue2 === 8) {
            console.log("Sorry");
            this.innerHtml =
              "<b>We do not have this Email-id registered with us</b>";
          }


          if (data && this.utils.checkRoleType(Utils.USER_TYPE.admin, this.dataValue2)) {

            localStorage.setItem("token2", this.awstok);

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Admin",
            });
            // If orgcode is null redirect to complete the registration process
            if (localStorage.getItem("orgcode") === 'null') {
              this.router.navigate(["/info-basic"]);
            }
            // else redirect to dashboard
            else {
              this.router.navigate(["/admindashboard"]);
            }
          }
          else if (data && this.utils.checkRoleType(Utils.USER_TYPE.superadmin, this.dataValue2)) {

            localStorage.setItem("token2", this.awstok);

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Superadmin",
            });

            this.router.navigate(["/superadmin/physicians"]);
          }

          else if (data && this.utils.checkRoleType(Utils.USER_TYPE.physician, this.dataValue2)) {

            localStorage.setItem("token2", this.awstok);

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Physician",
            });

            this.router.navigate(["/dashboard"]);
          }
          else if (data && this.utils.checkRoleType(Utils.USER_TYPE.front_desk, this.dataValue2)) {

            localStorage.setItem("token2", this.awstok);

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              type: "success",
              title: "Signed in as Front-Desk Person",
            });

            this.router.navigate(["/dashboard"]);
          }

          //forcing user to set new password if Old Password
          // does not match with Password Validations

          if (data && data["force_reset_password"]) {

            // SweetAlert

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 10000,
            });

            Toast.fire({
              type: "error",
              title: "Your Password Should Contain atleast One UpperCharacter, One LowerCharacter and One Number ",
            });

            this.router.navigate(["/setNewPass"], { queryParams: { email_id: localStorage.getItem("LogUsr") } });

          }

          // change password in case of temperory passwords of patients
          if (data && data["password_reset"] === false) {

            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 10000,
            });

            Toast.fire({
              type: "error",
              title: data['message'],
            });
            let data_email = localStorage.getItem("LogUsr");
            console.log("data", data_email)
            let buff = new Buffer(data_email);
            console.log("buff", buff)
            let base64data = buff.toString('base64');
            console.log("base64data", base64data)
            let data2 = base64data;
            this.router.navigate(["/setNewPass"], { queryParams: { email_id: base64data, account_type: this.user.account_type } });
          }

        },
        (error) => {
          this.spinner.hide();
          let message = "Something Went Worng!";
          if (error && error.error && error.error.error) message = error.error.error;
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 10000,
          });

          Toast.fire({
            type: "error",
            title: message,
          });


          // console.log(error);
          // let message = 'Something went wrong !'
          // if (error.error && error.error.internalError) {
          //   message = JSON.parse(error.error.internalError).message;
          // }
          // this.innerHtml = `<div class="text-danger">${message}</div>`;
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }
}
